/** Max length for the message field on the trial upgrade request callback modal. */
export const TRIAL_UPGRADE_REQUEST_CALLBACK_MESSAGE_MAX_LENGTH = 1000;
